import { render, staticRenderFns } from "./AllInvestmentsReceivablesTableCollectionOperation.vue?vue&type=template&id=4bcfb278&"
import script from "./AllInvestmentsReceivablesTableCollectionOperation.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesTableCollectionOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports